import {
  ApiPagination, Filters, RequestPagination, SimpleEnumType,
} from '@/types';
import {
  ProjectStatuses,
} from '@/enums';
import { Products } from '@/modules/products/types';

export namespace Projects {
  import CatalogProductItem = Products.CatalogProductItem;

  export enum Pages {
    PROJECTS = 'projects',
    PROJECT_DETAIL = 'project',
    PROJECT_NEW = 'projects/new-project'
  }

  export type Project = {
    [key: string]: unknown,
    id?: string | number,
    external_number: number | null,
    name: string | null,
    created_at: string | null,
    closed_at: string | null,
    total_amount: string | null
    shipment_at: string | null,
    organization: string | null,
    partner_contact_person: string | null,
    partner_contact_telephone: string| null,
    partner_contact_email: string | null,
    subpartner: string | null,
    sale_points_quantity: number | null,
    client_name: string | null,
    products_quantity: number | null,
    project_region_id: number | null,
    status: SimpleEnumType<ProjectStatuses> | null,
    client?: {
      name: string,
      inn: string,
      kpp_client: string,
    }[] | null,
    action: string | null,
  }

  export interface NewProject {
    [key: string]: unknown,
    organization_id: number | null,
    subpartner_id: number | null,
    shipment_at: string | null,
    partner_contact_person: string | null,
    partner_contact_email: string | null,
    partner_contact_telephone: string,
    sale_points_quantity: number | null,
    client_name: string | null,
    client_city: string | null,
    client_telephone: string,
    client_email: string | null,
    client_website: string | null,
    client_contact_person: string | null,
    client_contact_telephone: string,
    client_contact_email: string | null,
    description: string | null,
    client_ids: number[] | null
    project_region_id: number | null,
  }

  export interface NewProjectClients extends NewProject {
    client_ids: number[] | null
  }

  export interface HistoryPrice {
    agreed_price: string | null,
    agreed_quantity: number | null,
    client_price: string | null,
    date_agreed_price: string | null,
    id?: number | null,
    product_code: string | null,
    ordered_quantity: number | null,
  }

  export interface Product {
    [key: string]: unknown,
    agreed_price: number | null,
    agreed_quantity: number | null,
    client_price: string | null,
    desired_price: string | null,
    id?: number | null,
    price_rub?: number | null,
    quantity?: number | null,
    nomenclature: string | null,
    product_code: string | null,
    ordered_quantity: number | null,
    available_quantity: number | null,
    history: HistoryPrice[],
  }

  export interface Equipments {
    comment: string | null,
    group?: string | null,
    id?: number | null,
    name?: string | null,
    quantity: number | null,
  }
  export interface History {
    comment: string | null,
    created_at: string | null,
    id?: number | null,
    event_description: string | null,
    user_name: string | null,
  }

  export interface OrdersRealizations {
    created_at: string | null,
    external_number: string | null,
    id?: number | null,
    quantity: number | null,
    status: string | null,
    total_payment: number | null,
    total_price: number | null,
    type: string | null,
  }

  export interface Regions {
    id: number,
    external_id: string | null,
    name: string | null,
  }

  export interface Competitors extends Equipments {
    client_price: string | number,
    product_name: string | number,
  }

  export interface CatalogProduct {
    [key: string]: unknown,
    id: number,
    category_name: string,
    product_code: string,
    nomenclature: string,
    price: number,
    software_type_name: string | null
  }

  export interface CatalogProductResponse extends ApiPagination {
    data: {
      items: CatalogProduct[],
      filters: {
        categories: Products.CategoryFilterItem[],
        software_types: Products.CatalogFilterItem[],
        equipment_models: Products.EquipmentModelFilterItem[]
      }
    }
  }

  export type CatalogProductRequestFilters = {
    [key: string]: unknown,
    search: string,
    categories: number[];
    software_type: number | null;
    equipment_models: number[],
    is_favorite_only: boolean
  }

  export type CatalogProductRequest = {
    filters: CatalogProductRequestFilters,
    filters_exist: boolean,
    pagination: RequestPagination,
  }

  export interface AddProduct {
    product_code?: string | number,
    catalog_price?: number | null,
    quantity?: number | string,
    client_price?: string | null,
    desired_price?: string | null,
    id?: number | null,
    nomeclature?: string | null,
  }
}

export interface ProjectsFilters extends Filters {
  [key: string]: unknown,
  created_at: string | null;
  closed_at: string | null;
  organization_ids: string | null;
  statuses: ProjectStatuses | null;
  partner_contact_persons: string | null;
}

export interface DetailsFilters extends Filters {
  [key: string]: unknown,
  document_type?: boolean | null,
}

export interface ProjectToCartRequest {
  project_id?: string | number;
  items: Projects.Product[] | [],
}

export interface CheckingCartResponse {
  data: {
    cart_is_empty: boolean,
  }
}
